import { useMemo } from "react";
import { useUserStore } from "../store/userStore";
import { BillingPayment } from "../../Payments/types/payment";


export function useUserPayments(
  payments: BillingPayment[],
  user: { email?: string; phone?: string }
) {
  const { users } = useUserStore();

  return useMemo(() => {
    if (!user.email && !user.phone) return [];

    // Step 1: Match users by email (preferred) or phone
    const matchedUsers = users.filter(u => {
      if (user.email) {
        return u.email?.toLowerCase() === user.email.toLowerCase();
      }
      if (user.phone) {
        return u.phone === user.phone;
      }
      return false;
    });

    // Step 2: Collect all user IDs across services
    const userIds = matchedUsers.map(u => u.id);

    // Step 3: Match payments belonging to any of the user IDs
    const matchedPayments = payments.filter(pay =>
      userIds.includes(pay.userid)
    );

    // Step 4: Transform into a unified structure
    return matchedPayments.map(pay => {
      const matchedUser = matchedUsers.find(u => u.id === pay.userid);
      return {
        service_name: pay.service_name,
        amount: pay.amount,
        product: pay.product,
        status: pay.status,
        method: pay.payment_gateway,
        date: pay.created_at,
        location: matchedUser?.country ?? null,
        registeredAt: matchedUser?.createdAt ?? null,
      };
    });
  }, [users, payments, user]);
}
